const baseUrl = process.env.REACT_APP_BASE_URL || "develop--dreame-api.warrantyservices.com.au";
const country = process.env.REACT_APP_COUNTRY || "AU";
const customerBaseUrl = process.env.REACT_APP_CUSTOMER_BASE_URL || "";
const countryBrandId = process.env.REACT_APP_COUNTRY_BRAND_ID || "";

const apiUrl = `https://${baseUrl}/api/`;
const config = {
  backendServer: apiUrl,
  country: country,
  baseUrl: baseUrl,
  customerBaseUrl,
  countryBrandId,
};

export default config;
